// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__a4Utv","icon":"Badge_icon__z6uWh","spinner-wrapper":"Badge_spinner-wrapper__3DmIz","spinner":"Badge_spinner__787ej"};